import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import '../assets/styles/Footer.scss'

function Footer() {
  return (
    <footer>
      <div>
        <a href="https://github.com/alexm622" target="_blank" rel="noopener noreferrer" aria-label="GitHub"><GitHubIcon/></a>
        <a href="https://www.linkedin.com/in/alexander-comeau/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><LinkedInIcon/></a>
      </div>
      <p>&copy; 2026 Alexander Comeau. All rights reserved.</p>
    </footer>
  );
}

export default Footer;